import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, FormFeedback, Input, Label } from 'reactstrap';
import Body from '../Components/layout/Body';
import TextWithMoreInfo from '../Components/layout/TextWithMoreInfo';

const OTHER_HELP = `
  <div>
    <p><strong>Purpose: </strong>Here is where you can note other issues related to client abilities that haven't already been entered. Very generally, these may include:
      <ul>
        <li>Hearing</li>        
        <li>Tactile sensation</li>        
        <li>Sensory defensiveness</li>        
        <li>Proprioception</li>        
        <li>Motivation / interest</li>
        <li>Health status / prognosis</li>        
      </ul>
    </p>
    <p>This helps you document and consider these issues and how they may affect alternative access for this client.</p>
  </div>
`

const propTypes = {
  otherIssues: PropTypes.string, 
  onChangeOtherIssues: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
}

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  otherIssues: ''
};

class OtherIssuesForm extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for entering other characteristics.
  //Calls the setter that's passed in by the parent, when the user types.
  //That setter changes the state of the issues var in the parent, 
  //which triggers a new render of the view with the new var value.

  render(){
    const otherIssues = this.props.otherIssues;
    const onChangeOtherIssues = this.props.onChangeOtherIssues;
    const onSubmit = this.props.onSubmit;

    return(
    <>
    {/* TODO Resolve. currently supports hitting Enter to submit (Continue) 
    https://ux.stackexchange.com/questions/130603/which-is-best-for-an-enter-note-field-an-enter-button-or-hitting-the-return-k
    Based on traditions of user interfaces, most users probably expect to press Enter OR 
    click a Save button to enter text in a field. 
    Giving both options often makes the most sense. 
    On the other hand, if saving the text also sends you to another screen, 
    then you want to prevent accidental actions, probably by not allowing Enter, 
    and by labeling the button "Save and Close" or "Save and Exit" or similar.
    */}
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="other-issues">
          <TextWithMoreInfo 
            text="Other issues:" 
            infoText="(such as: proprioception, tactile sensation, sensory defensiveness)" 
          />
        </Label>
        <Input
          id="other-issues"
          value={otherIssues}
          onChange={onChangeOtherIssues}
          name="other-issues"
          type="textarea"
          // invalid={strengths !== ''}
        />
        {/* <FormFeedback>{methodNameError}</FormFeedback> */}
      </FormGroup>
    </Form>
    </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function EvaluateAbilitiesOtherIssues(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const otherIssues = props.otherIssues;
  const onChangeOtherIssues = props.onChangeOtherIssues;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  // console.log("rendering EvaluateAbiltiiesOtherIssues with issues: " + otherIssues);
  // console.log("rendering CurrentMethodEntry. callback type:  " + typeof(onChangeMethodName));

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-superpowers",
    pageSymbolClassName: "aa-section-symbol eval",
    title: `List any other characteristics that might affect ${firstName}'s access`,
    subTitle: `Include sensory abilities, hearing, or other areas we haven't covered yet.`,
    learnMore: {linkText: "Learn More about other characteristics that might be relevant",
                title: "Other Characteristics",
                content: OTHER_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true,
  }

  useEffect(() => {
    console.log('EAOther mounted');
    return () => {
      console.log('EAOther unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <OtherIssuesForm 
          firstName={firstName} 
          pronouns={pronouns}
          otherIssues={otherIssues} 
          onChangeOtherIssues={onChangeOtherIssues}
          onSubmit={onContinue}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

EvaluateAbilitiesOtherIssues.propTypes = propTypes;
EvaluateAbilitiesOtherIssues.defaultProps = defaultProps;

export default EvaluateAbilitiesOtherIssues;

